<template>
    <div>
        <v-container>
            <v-text-field v-if="pageType == 'Canvas'" label="Image URL or Link" dense outlined v-model="item.image"></v-text-field>
            <v-img :src="item.image"
                :style="styles.custom"
                :contain="styles.contain"
                :class="styles.class"
                :width="styles.width"
                :height="styles.height"
                :max-height="styles.maxHeight"
                :max-width="styles.maxWidth"
            >
            </v-img>
        </v-container>
    </div>
</template>

<script>
export default {
    props: ["item", "styles", "indexes"],
    computed: {
        adjustedClass () {
            return ""
        }
    }
}
</script>
